export const validationWorkoutId = (row: IChallengeRoutines) => {
  let hasWorkoutId = false;

  if (row.workout_id) {
    hasWorkoutId = true;
  }

  if (!hasWorkoutId && row.name && row.name.length > 0) {
    return false;
  }

  return hasWorkoutId;
};

export const validationRoutineRow = (row: IChallengeRoutines, idx: number) => {
  const result = {
    error: false,
    message: '',
  };
  let errorCount = 0;

  // challenge_condition: null
  // count: 0
  // count_placeholder: ""
  // date: 4
  // id: 9177
  // name: ""
  // part: ""
  // set_count: 0
  // weight_multiplier: 0
  // weight_placeholder: ""
  // workout_id: null

  if (!row.workout_id) {
    if (row.name && row.name.length > 0) {
      errorCount += 1;
    }

    if (row.challenge_condition && row.challenge_condition.id) {
      errorCount += 1;
    }

    if (row.count > 0 || row.count_placeholder.length > 0) {
      errorCount += 1;
    }

    if (row.weight_multiplier > 0 || row.weight_placeholder.length > 0) {
      errorCount += 1;
    }

    if (row.set_count > 0) {
      errorCount += 1;
    }
  }

  if (errorCount > 0) {
    result.error = true;
    result.message = `${row.date}일차의 ${idx}번째 workout_id가 비어있습니다. 운동을 다시 선택해 주세요.`;

    return result;
  }

  return result;
};
